import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import { Form, Grid, Header, Button, Icon } from 'semantic-ui-react'
import { FormValidation, Field } from '../components'
import { fields } from '../../common/lib/redux-fields'
import { createAttendanceHeader, updateAttendanceHeader } from '../../common/attendances/actions'
import {
  validateCreate,
  validateUpdate,
} from '../../common/attendances/validations'
import { loadCompanies } from '../../common/companies/actions'
import { loadActiveLocations } from '../../common/locations/actions'
import { courseTypesFormated } from '../../common/config'

const { Row, Column } = Grid

const courseTypeOptions = Object.keys(courseTypesFormated).map(
  key => ({ value: key, text: courseTypesFormated[key].name }),
)

class AttendanceHeaderForm extends React.Component {
  async submit(e) {
    e.preventDefault()
    const { fields, submit, attendance, createAttendanceHeader, updateAttendanceHeader } = this.props
    const isUpdate = attendance && !!attendance._id
    const values = fields.$values()
    let submissionFunction = createAttendanceHeader
    if (isUpdate) {
      values._id = attendance._id
      submissionFunction = updateAttendanceHeader
    }
    if (await submit(values, submissionFunction) !== false) {
      fields.$reset()
    }
  }
  
  componentWillMount() {
    this.props.loadActiveLocations({ sort: 'nameSort' })
    this.props.loadCompanies({ sort: 'nameSort' })
  }

  componentWillUnmount() {
    this.props.fields.$reset()
  }
  
  render() {
    const { fields, attendance, companyOptions, locationOptions, errors, submitting, submitSuccessfull, errorMessage } = this.props

    if (submitSuccessfull && attendance && attendance._id) return <Redirect to={'/attendances/' + attendance._id} />
    if (submitSuccessfull) return <Redirect to='/attendances/' />

    const fieldData = Object.assign({}, fields)
    errors.forEach(error => {
      if (error.detail && error.detail.field && fieldData[error.detail.field]) {
        fieldData[error.detail.field].error = error.message
      }
    })

    return (
      <Form loading={submitting} size="big">
        <Grid>
          <Row>
            <Column>
              <Header as="h2">Základní údaje</Header>
            </Column>
          </Row>
          <Field label="Dopravce" type="select" options={companyOptions} {...fieldData.company} required />
          <Field label="Lokace" type="select" options={locationOptions} {...fieldData.location} required />
          <Field label="Kurz" type="select" options={courseTypeOptions} {...fieldData.courseType} required />
          <Field label="Datum" type="date" {...fieldData.date} required />
        </Grid>

        <Grid>
          <Row>
            <Column>
              <Header as="h2">Informace</Header>
            </Column>
          </Row>
          <Field label="Poznámka" {...fieldData.note} />
        </Grid>

        {errorMessage}

        <Grid>
          <Row>
            <Column>
              {attendance && attendance._id &&
                <Link to={"/attendances/" + attendance._id}><Button>Storno</Button></Link>
              }
              <Button type="submit" color="red" onClick={(e)=>this.submit(e)}> Uložit a dále » </Button>
            </Column>
          </Row>
        </Grid>
      </Form>
    )
  }
}

AttendanceHeaderForm.defaultProps = {
  attendance: null,
  errors: [],
  submitting: false,
  submitSuccessfull: false,
  errorMessage: null,
}

AttendanceHeaderForm.propTypes = {
  fields: React.PropTypes.object.isRequired,
  attendance: React.PropTypes.object,
  errors: React.PropTypes.array,
  companyOptions: React.PropTypes.array.isRequired,
  locationOptions: React.PropTypes.array.isRequired,
  loadCompanies: React.PropTypes.func.isRequired,
  loadActiveLocations: React.PropTypes.func.isRequired,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
  errorMessage: React.PropTypes.any
}

AttendanceHeaderForm = fields(AttendanceHeaderForm, {
  path: 'AttendanceHeaderForm',
  fields: ['company','location','courseType','date','note'],
  getInitialState: (props) => {
    const { attendance } = props
    if (attendance && attendance._id) return attendance.toJS()
    return { }
  },
})

AttendanceHeaderForm = FormValidation(AttendanceHeaderForm, (props) => {
  const { attendance } = props
  let submissionValidation
  if (attendance && attendance._id) submissionValidation = validateUpdate
  else submissionValidation = validateCreate
  return { submissionValidation }
})

export default connect((state) => ({
  viewer: state.attendances.viewer,
  attendance: state.attendances.current,
  companyOptions: state.companies.all.map(c => ({ value: c._id, text: c.name })).toArray(),
  locationOptions: state.locations.all.map(l => ({ value: l._id, text: l.name })).toArray(),
}), { createAttendanceHeader, updateAttendanceHeader, loadCompanies, loadActiveLocations })(AttendanceHeaderForm)



// WEBPACK FOOTER //
// ./src/browser/forms/AttendanceHeader.js